import { render, staticRenderFns } from "./header-primary.vue?vue&type=template&id=f94e0e08&"
import script from "./header-primary.vue?vue&type=script&lang=js&"
export * from "./header-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports